/* src/app/admin-dashboard/contact-book/contact-book.component.css */
.cbk-wrap {
  padding: 16px;
}
.cbk-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.cbk-search {
  flex: 0 1 420px;
}
.cbk-count {
  color: #64748b;
  font-size: 13px;
}
.cbk-spacer {
  flex: 1 1 auto;
}
.cbk-table-wrap {
  overflow-x: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}
.cbk-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}
.cbk-table th {
  text-align: left;
  padding: 10px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .4px;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}
.cbk-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.cbk-table tbody tr {
  cursor: pointer;
}
.cbk-table tbody tr:hover {
  background: #f8fafc;
}
.cbk-strong {
  font-weight: 600;
  color: #0f172a;
}
.cbk-nowrap {
  white-space: nowrap;
}
.cbk-muted {
  color: #94a3b8;
}
.cbk-empty {
  text-align: center;
  padding: 24px;
}
.cbk-card {
  display: inline-block;
  margin: 2px 4px 2px 0;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #0f172a;
  font-size: 12px;
  text-decoration: none;
}
.cbk-card:hover {
  background: #e2e8f0;
}
.cbk-actions {
  width: 48px;
  text-align: right;
}
/*# sourceMappingURL=contact-book.component.css.map */
